/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {useIntl} from 'react-intl'
import {KTSVG, toAbsoluteUrl} from '../../../_metronic/helpers'
import './style.css'
import 'react-date-range/dist/styles.css' // main css file
import 'react-date-range/dist/theme/default.css' // theme css file
import 'react-date-range/dist/styles.css' // main style file
import 'react-date-range/dist/theme/default.css' // theme css file
import Select from 'react-select'
import DateRanger from '../dashboard/DateRanger'
import CustomerWiseShipmentBarChart from '../dashboard/CustomerWiseShipmentBarChart'
import OnTimeAndLatePieChart from '../dashboard/OnTimeAndLatePieChart'
import DeliveryRegionDonutChart from '../dashboard/DeliveryRegionDonutChart'
import DamageLostPieChart from '../dashboard/GPSPieChart'
import NetProfitLineChart from '../dashboard/NetProfitLineChart'



const options = [
  {value: 'c1', label: 'Customer 1'},
  {value: 'c2', label: 'Customer 2'},
  {value: 'c3', label: 'Customer 3'},
]
interface Dashboard3Props {
  currency: string // Receive the currency as a prop
  amount: number // Add the amount property
}

interface FinancialDashboardProps {
  currency: string
}

const Dashboard3: FC<Dashboard3Props> = ({currency, amount}: any) => (
  <>
    <div className=''>
      <div
        className='d-flex flex-wrap flex-stack mb-4 ms-2 py-2 ps-5 rounded'
        style={{
          background: 'linear-gradient(to right, #1e1e2d , #f5f8fa)',
        }}
      >
        <div className='d-flex align-items-center me-1'>
          <h2 className='text-white fw-bold my-1'>Financial Dashboard</h2>
        </div>
        <div className='d-flex justify-content-end px-2'>
          <div className='min-w-150px'>
            <Select options={options} placeholder='Select Customer'  />
          </div>
          <div className='m-0'>
            <a
              href='#'
              className={
                'btn btn-sm btn-flex fw-semibold text-gray-600 bg-white bg-hover-danger text-hover-white ms-3 border border-1 border-gray-300 py-3'
              }
              data-kt-menu-trigger='click'
              data-kt-menu-placement='bottom-end'
            >
              <KTSVG
                path='/media/icons/duotune/files/fil002.svg'
                className='svg-icon-6 svg-icon-danger me-3'
              />
              Filter Date Range
            </a>
            <DateRanger  />
          </div>
        </div>
      </div>

      <div className='d-flex flex-wrap'>
        <div className='d-flex flex-grow-1 mx-2'>
          <div
            className='card mb-4 card-xl-stretch w-100'
            style={{
              // background:
              //   'linear-gradient(-120deg, rgba(97, 67, 133, 1) 60%, rgba(81, 99, 149, 1) 100%)',
              minWidth: '400px',
            }}
          >
            <div className='card-body small-card-padding rounded'>
              <div className='d-flex align-items-center flex-w'>
                <div className='rounded small-card-img '>
                  <div className='symbol symbol-50px p-1 bg-light-danger me-4'>
                    <KTSVG
                      path='/media/icons/duotune/graphs/gra012.svg'
                      className='svg-icon-danger svg-icon-3hx'
                    />
                  </div>
                </div>
                <div className='d-flex flex-column w-100 text-start align-items-center'>
                  <div className='d-flex justify-content-between mt-2 w-100'>
                    <span
                      className='d-flex align-items-center card-titles'
                      style={{fontWeight: 900}}
                    >
                      {currency}{' '}
                      {currency === 'LKR'
                        ? (1340000 * 0.01834).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })
                        : (1340000).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                    </span>
                  </div>
                  <div className='d-flex justify-content-between flex-1 w-100'>
                    <span className='card-title-sub fw-semibold text-gray-600 mb-2'>
                      Total Revenue (as of today)
                    </span>
                    <div className='d-flex align-items-center'>
                      <KTSVG
                        path='/media/icons/duotune/arrows/arr003.svg'
                        className='svg-icon-1 svg-icon-success me-2'
                      />
                      <div className='card-title-sub fw-bolder text-success'>3.5%</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='d-flex flex-grow-1 mx-2'>
          <div
            className='card mb-4 card-xl-stretch w-100'
            style={{
              // background:
              //   'linear-gradient(-120deg, rgba(67, 206, 162, 1) 60%, rgba(24, 90, 157, 1) 100%)',
              minWidth: '400px',
            }}
          >
            <div className='card-body small-card-padding rounded'>
              <div className='d-flex align-items-center flex-w'>
                {' '}
                <div className='rounded small-card-img'>
                  <div className='symbol symbol-50px me-4 p-1 bg-light-danger'>
                    <KTSVG
                      path='media/icons/duotune/graphs/gra003.svg'
                      className='svg-icon-danger svg-icon-3hx'
                    />
                  </div>
                </div>
                <div className='d-flex flex-column w-100 text-start align-items-center '>
                  <div className='d-flex justify-content-between mt-2 w-100'>
                    <span
                      className='d-flex align-items-center card-titles'
                      style={{fontWeight: 900}}
                    >
                      {currency}{' '}
                      {currency === 'LKR'
                        ? (2340000 * 0.01834).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })
                        : (2340000).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                    </span>
                  </div>
                  <div className='d-flex justify-content-between flex-1 w-100'>
                    <span className='card-title-sub fw-semibold text-gray-600 mb-2'>
                      Total Cost (as of today)
                    </span>
                    <div className='d-flex align-items-center'>
                      <KTSVG
                        path='/media/icons/duotune/arrows/arr066.svg'
                        className='svg-icon-1 svg-icon-white me-2'
                      />
                      <div className='card-title-sub fw-bolder text-danger'>3%</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='d-flex flex-grow-1 mx-2'>
          <div
            className='card mb-4 card-xl-stretch w-100'
            style={{minWidth: '400px'}}
            // style={{
            //   background:
            //     'linear-gradient(-120deg, rgba(243,147,0,255) 60%, rgba(233,84,13,255) 100%)',
            // }}
          >
            <div className='card-body small-card-padding rounded'>
              <div className='d-flex align-items-center flex-w'>
                {' '}
                <div className='rounded small-card-img'>
                  <div className='symbol symbol-50px me-4 p-1 bg-light-danger'>
                    <KTSVG
                      path='/media/icons/duotune/ecommerce/ecm006.svg'
                      className='svg-icon-danger svg-icon-3hx'
                    />
                  </div>
                </div>
                <div className='d-flex flex-column w-100 text-start align-items-center '>
                  <div className='d-flex justify-content-between mt-2 w-100'>
                    <span
                      className='d-flex align-items-center card-titles'
                      style={{fontWeight: 900}}
                    >
                      {currency}{' '}
                      {currency === 'LKR'
                        ? (1000 * 0.01834).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })
                        : (1000).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                    </span>
                  </div>
                  <div className='d-flex justify-content-between flex-1 w-100'>
                    <span className='card-title-sub fw-semibold text-gray-600 mb-2'>
                      Cost Per KM
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='d-flex flex-grow-1 mx-2'>
          <div
            className='card mb-4 card-xl-stretch w-100'
            style={{minWidth: '400px'}}
            // style={{
            //   background:
            //     'linear-gradient(-120deg, rgba(243,147,0,255) 60%, rgba(233,84,13,255) 100%)',
            // }}
          >
            <div className='card-body small-card-padding rounded'>
              <div className='d-flex align-items-center flex-w'>
                {' '}
                <div className='rounded small-card-img'>
                  <div className='symbol symbol-50px me-4 p-1 bg-light-danger'>
                    <KTSVG
                      path='/media/icons/duotune/graphs/gra001.svg'
                      className='svg-icon-danger svg-icon-3hx'
                    />
                  </div>
                </div>
                <div className='d-flex flex-column w-100 text-start align-items-center '>
                  <div className='d-flex justify-content-between mt-2 w-100'>
                    <span
                      className='d-flex align-items-center card-titles'
                      style={{fontWeight: 900}}
                    >
                      {currency}{' '}
                      {currency === 'LKR'
                        ? (1400000 * 0.01834).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })
                        : (1400000).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                    </span>
                  </div>
                  <div className='d-flex justify-content-between flex-1 w-100'>
                    <span className='card-title-sub fw-semibold text-gray-500 mb-2'>
                      Total Profit (as of today)
                    </span>
                    <div className='d-flex align-items-center'>
                      <KTSVG
                        path='/media/icons/duotune/arrows/arr004.svg'
                        className='svg-icon-1 svg-icon-danger me-2'
                      />
                      <div className='fs-2 fw-bolder text-danger'>3%</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='mx-2'>
        <div className='row gx-4 gy-2'>
          <div className='col-lg-12 col-xl-12 col-xxl-12'>
            {' '}
            <NetProfitLineChart />
          </div>
        </div>
      </div>
    </div>
  </>
)

const FinancialDashboard: FC<FinancialDashboardProps> = ({currency, amount}: any) => {
  return (
    <>
      {/* <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.DASHBOARD'})}</PageTitle> */}
      <Dashboard3 currency={currency} amount={amount} />
    </>
  )
}

export {FinancialDashboard}
